var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2621_29252)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 48,
    height: 48,
    rx: 10,
    fill: "#E8EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8984 30.3766C18.121 30.3767 19.3352 30.1808 20.4918 29.7969",
    stroke: "#2948A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5627 16.6588C27.3136 15.8175 26.9593 15.0089 26.5078 14.251",
    stroke: "#2948A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1043 30.3755C35.4926 29.3503 34.7103 28.4302 33.7891 27.6523",
    stroke: "#2948A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1005 19.627C34.8781 19.6272 33.6642 19.8233 32.5078 20.2074",
    stroke: "#2948A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4531 33.3428C25.7022 34.1841 26.0565 34.9927 26.508 35.7506",
    stroke: "#2948A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8984 19.627C17.5101 20.6519 18.2921 21.572 19.213 22.3501",
    stroke: "#2948A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5044 30.3754C26.991 29.5583 27.2472 28.6315 27.2472 27.6881C27.2472 26.7447 26.991 25.8179 26.5044 25.0008C26.0179 24.1838 25.318 23.5053 24.4752 23.0336C23.6324 22.5619 22.6763 22.3135 21.7031 22.3135",
    stroke: "#2948A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7031 27.6888C22.6763 27.6888 23.6324 27.4405 24.4752 26.9687C25.318 26.497 26.0179 25.8185 26.5044 25.0015C26.991 24.1844 27.2472 23.2576 27.2472 22.3142C27.2472 21.3708 26.991 20.444 26.5044 19.627",
    stroke: "#2948A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4835 21.7156C35.1113 21.0858 35.6575 20.3841 36.1098 19.626C34.8713 18.0598 33.0875 16.9836 31.091 16.5981C29.0945 16.2126 27.0215 16.544 25.2584 17.5306C23.4953 18.5172 22.1625 20.0917 21.5083 21.9605C20.8542 23.8292 20.9234 25.8649 21.703 27.6879C22.1896 26.8709 22.8895 26.1925 23.7323 25.7208C24.5751 25.2491 25.5311 25.0008 26.5043 25.0008C27.4775 25.0008 28.4335 25.2491 29.2763 25.7208C30.1191 26.1925 30.819 26.8709 31.3056 27.6879C30.066 29.2513 28.2828 30.3248 26.2876 30.7087C24.2925 31.0926 22.2214 30.7607 20.4599 29.7748C18.6984 28.7889 17.3664 27.2161 16.7118 25.3491C16.0573 23.4822 16.1248 21.4483 16.9017 19.626C17.804 19.6261 18.7029 19.7329 19.5785 19.9442",
    stroke: "#2948A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4254 30.058C34.3017 30.2694 35.2013 30.3762 36.1043 30.3761C36.8819 28.5537 36.9498 26.5193 36.2954 24.6519C35.6409 22.7845 34.3087 21.2113 32.5468 20.2252C30.7849 19.2391 28.7134 18.9073 26.7179 19.2916C24.7224 19.6759 22.939 20.7501 21.6997 22.3142C22.1864 23.1312 22.8862 23.8096 23.729 24.2813C24.5718 24.753 25.5278 25.0013 26.501 25.0013C27.4742 25.0013 28.4302 24.753 29.273 24.2813C30.1158 23.8096 30.8157 23.1312 31.3023 22.3142C32.0793 24.1365 32.1467 26.1704 31.4922 28.0374C30.8376 29.9043 29.5056 31.4771 27.7441 32.463C25.9826 33.449 23.9115 33.7809 21.9164 33.397C19.9213 33.0131 18.138 31.9395 16.8984 30.3761C17.3508 29.618 17.8969 28.9163 18.5247 28.2865",
    stroke: "#2948A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7795 32.4443C27.5442 33.6073 27.1121 34.7245 26.5006 35.7507C28.5173 35.4921 30.3684 34.5319 31.7092 33.0488C33.0501 31.5658 33.7893 29.6609 33.7893 27.6888C33.7893 25.7168 33.0501 23.8119 31.7092 22.3289C30.3684 20.8458 28.5173 19.8856 26.5006 19.627C26.014 20.444 25.7578 21.3708 25.7578 22.3142C25.7578 23.2576 26.014 24.1844 26.5006 25.0015C26.9872 25.8185 27.687 26.497 28.5298 26.9687C29.3726 27.4405 30.3287 27.6888 31.3019 27.6888",
    stroke: "#2948A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2215 17.5581C25.4564 16.395 25.8883 15.2775 26.4996 14.251C24.4829 14.5096 22.6318 15.4698 21.291 16.9529C19.9502 18.4359 19.2109 20.3408 19.2109 22.3129C19.2109 24.2849 19.9502 26.1898 21.291 27.6729C22.6318 29.1559 24.4829 30.1161 26.4996 30.3748C26.013 29.5577 25.7568 28.6309 25.7568 27.6875C25.7568 26.7441 26.013 25.8173 26.4996 25.0002C26.9862 24.1832 27.686 23.5047 28.5288 23.033C29.3717 22.5612 30.3277 22.3129 31.3009 22.3129",
    stroke: "#2948A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2621_29252",
    x: 0.5,
    y: 0.5,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2621_29252"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2621_29252",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiSquare);
export default __webpack_public_path__ + "static/media/AI-square.c6891e8946aad977dc79b04a2147078f.svg";
export { ForwardRef as ReactComponent };